import React from 'react';
import { PetInterface } from 'types/pet';
import { KibHeartFillIcon } from '@chewy/kib-icons-react';
import { PetAvatar, AvatarTypes, AvatarSizes } from '@chewy/pet-profile-pet-avatar';
import { ApiPetProfileAvatarImageSourceEnum } from '../../api/generated-client/PetProfile-Service-A.v1/models';
import './memorial-header.scss';

export default function MemorialHeader({
  petProfile,
  avatarUrl,
  avatarSrc,
  hasPassed,
}: {
  petProfile: PetInterface;
  avatarUrl?: string;
  avatarSrc?: string;
  hasPassed?: boolean;
}) {
  const hasCustomAvatar = avatarUrl && avatarSrc === ApiPetProfileAvatarImageSourceEnum.Photo;
  const strokeType = hasPassed ? AvatarTypes.MemorialDeceased : AvatarTypes.MemorialOther;
  const rememberingCopy = 'Remembering';

  const showBreedName =
    petProfile.petBreedName !== 'Other' && petProfile.petBreedName !== 'UNKNOWN';

  let displayBreed;
  if (petProfile.secondaryBreedName && petProfile.secondaryBreedName === 'Mixed / Unknown') {
    displayBreed = petProfile.petBreedName + ' / Mixed';
  } else if (petProfile.secondaryBreedName) {
    displayBreed = petProfile.petBreedName + ` / ${petProfile.secondaryBreedName}`;
  } else if (petProfile.petBreedName === 'Mixed / Unknown') {
    displayBreed = 'Mixed Breed';
  } else {
    displayBreed = petProfile.petBreedName;
  }

  return (
    <div className="memorial-header" data-testid="memorial-header">
      <div className="memorial-header__info" data-testid="memorial-header-info">
        {hasCustomAvatar ? (
          <PetAvatar
            className="pet-avatar-button__image memorial-header__avatar"
            data-testid="memorial-pet-avatar"
            alt="pet avatar"
            size={AvatarSizes.MEDIUM}
            src={avatarUrl}
            strokeType={strokeType}
          />
        ) : (
          <KibHeartFillIcon
            className="memorial-header__heart memorial-header__avatar"
            data-testid="memorial-header-heart"
          />
        )}

        <h1 className="memorial-header__title" data-testid="memorial-header-title">
          {rememberingCopy} <br />
          <span className="memorial-header__name">{petProfile.name}</span>
        </h1>
        {petProfile.petBreedName && showBreedName && (
          <div className="memorial-header__details" data-testid="memorial-header-details">
            {displayBreed}
          </div>
        )}
      </div>
    </div>
  );
}
